import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@shared/contexts/AuthContext";
import {
  expireStaffSession,
  hasStaffSessionCookie,
} from "@shared/lib/staffSession";

// F-W (2026-10-05): the auth state is read from the cookie at page load, so
// a session that expired while the app stayed open still looked signed in
// (cached pages kept rendering). Re-check the cookie on every guarded
// render; if it's gone, end the session ("Your session has expired").
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const expired = isAuthenticated && !hasStaffSessionCookie();

  useEffect(() => {
    if (expired) expireStaffSession();
  }, [expired]);

  if (!isAuthenticated) {
    return <Navigate to="/staff/login" replace />;
  }
  if (expired) return null;

  return children;
};

export default ProtectedRoute;
